"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetStartedButton = void 0;
const modal_context_1 = require("root/src/client/v2/common/contexts/modal.context");
const SignInWithProvidersModal_1 = require("root/src/client/v2/auth/features/SignInWithProvidersModal");
const useHasTokens_1 = require("root/src/client/v2/userData/hooks/useHasTokens");
const useIsMobileResolution_1 = require("root/src/client/v2/browser/hooks/useIsMobileResolution");
const useAuthentication_1 = require("root/src/client/v2/auth/hooks/useAuthentication");
const useUserData_1 = require("root/src/client/v2/userData/hooks/useUserData");
const useIsCreator_1 = require("root/src/client/v2/auth/hooks/useIsCreator");
const useIsViewer_1 = require("root/src/client/v2/auth/hooks/useIsViewer");
function useGetStartedButton() {
    const modal = (0, modal_context_1.useModal)();
    const showSignInWithProvidersModal = () => modal.show(<SignInWithProvidersModal_1.SignInWithProvidersModal />);
    const { authentication } = (0, useAuthentication_1.useAuthentication)();
    const { isCreator } = (0, useIsCreator_1.useIsCreator)();
    const { isViewer } = (0, useIsViewer_1.useIsViewer)();
    const { isLoading } = (0, useUserData_1.useUserData)();
    const { hasTokens } = (0, useHasTokens_1.useHasTokens)();
    const { isMobileResolution } = (0, useIsMobileResolution_1.useIsMobileResolution)();
    const isTargetGroup = isCreator || isViewer;
    const displayGetStartedButton = authentication
        && !isLoading
        && !isMobileResolution
        && !hasTokens
        && isTargetGroup;
    return {
        showSignInWithProvidersModal,
        displayGetStartedButton,
    };
}
exports.useGetStartedButton = useGetStartedButton;
